import Lottie, { type LottieComponentProps } from 'lottie-react'
import chatJson from '@/assets/lottie/chat-lottie.json'

interface LottieLoadingProps extends Partial<LottieComponentProps> {
  className?: string
}

export function LottieChat({ className, ...props }: LottieLoadingProps) {
  return (
    <div className={className}>
      <Lottie animationData={chatJson} {...props} />
    </div>
  )
}
